<button
  type="button"
  role="switch"
  data-testid="shared-switch"
  [ngClass]="switchClasses"
  [attr.aria-checked]="!!value"
  [attr.aria-disabled]="isDisabled || null"
  [attr.aria-label]="ariaLabel ?? null"
  (click)="onClick()"
></button>
